<template>
  <!-- ✅ Show only when there are images -->
  <v-row v-if="images.length > 0 && !shouldHideDialog" justify="center">
    <v-dialog class="containers ads-popup" v-model="showPopup" persistent style="z-index: 20020 !important;">
      <div style="width: 100%; position: relative;" class="m-auto-o">
        <vueper-slides
          ref="vueperSlides"
          :dragging-distance="50"
          :arrows="false"
          :bullets="true"
          :current-slide="currentImageIndex"
          style="height: 100%;"
          :touch-dragging="true"
          :key="slideshowKey"
        >
          <vueper-slide
            v-for="(slide, i) in images"
            :key="i"
            :image="slide"
            class="slide-image"
            style="height: 100%; background-size: cover;"
          />
        </vueper-slides>

        <div class="d-flex position-absolute">
          <div class="mr-2 mt-1">{{ $t('message.skip') }} {{ remainingTime }}</div>
          <div class="box-x" @click="closePopup">
            <i class="fas fa-times"></i>
          </div>
        </div>
      </div>
    </v-dialog>
  </v-row>

  <!-- ✅ Show single image version for small screens -->
  <v-row v-else-if="images.length > 0 && shouldHideDialog" justify="center">
    <v-dialog v-model="showPopup" persistent max-width="100%" style="z-index: 20020 !important;">
      <div style="width: 100%; height: 100%; position: relative;" class="m-auto-o">
        <img :src="currentImage" class="mb-img" alt="Image" style="width: 100%; height: 100%;">
        <div class="d-flex position-absolute">
          <div class="mr-2 mt-1">{{ $t('message.skip') }} {{ remainingTime }}</div>
          <div class="box-x" @click="closePopup">
            <i class="fas fa-times"></i>
          </div>
        </div>
      </div>
    </v-dialog>
  </v-row>
</template>

<script>
import { VueperSlides, VueperSlide } from 'vueperslides';
import 'vueperslides/dist/vueperslides.css';
import axios from 'axios';

export default {
  components: { VueperSlides, VueperSlide },
  data() {
    return {
      showPopup: false,
      remainingTime: 6,
      intervalId: null,
      slideshowIntervalId: null,
      currentImageIndex: 0,
      slideshowKey: 0,
      images: [],
      imagelangth: '',
      setAdspopup: localStorage.getItem('adspopup')
    };
  },
  computed: {
    currentImage() {
      return this.images[this.currentImageIndex];
    },
    shouldHideDialog() {
      return this.$vuetify.breakpoint.xsOnly || this.$vuetify.breakpoint.width < 500;
    }
  },
  watch: {
    currentImageIndex() {
      this.slideshowKey++;
    }
  },
  methods: {
    async getAds() {
      const url = this.$url + `slide-shows/list`;

      const config = {
        method: "POST",
        url,
        headers: {
          ...this.$header,
          'Content-Type': 'application/json'
        },
        data: {
          page: 1,
          rowsPerPage: 10,
          searchText: "string"
        }
      };

      axios(config)
        .then((response) => {
          if (response.data.header.result && response.data.header.statusCode === 200) {
            if (response.data.body.status || response.data.body.message === 'Success') {
              const image = response.data.body.data;
              this.imagelangth = image.length;

              // ✅ Only show popup if there are images
              if (image.length > 0) {
                this.images = image.map(item => this.$imgUrlAds + item.image);
                this.showPopupOnlyone();
              } else {
                this.showPopup = false;
              }
            } else {
              console.warn(response.data.body.message);
            }
          }
        })
        .catch((error) => {
          console.error(error);
        });
    },

    startTimer() {
      this.intervalId = setInterval(() => {
        if (this.remainingTime > 1) {
          this.remainingTime--;
        } else {
          this.closePopup();
        }
      }, 1000);
    },

    resizeVueperSlides() {
      this.$nextTick(() => {
        if (this.$refs.vueperSlides) {
          this.$refs.vueperSlides.$emit('resize');
        }
      });
    },

    startSlideshow() {
      if (this.images.length === 0) return;
      this.slideshowIntervalId = setInterval(() => {
        this.currentImageIndex = (this.currentImageIndex + 1) % this.images.length;
        this.$nextTick(() => {
          if (this.$refs.vueperSlides) {
            this.$refs.vueperSlides.goToSlide(this.currentImageIndex);
          }
        });
      }, 6000 / this.imagelangth);
    },

    stopSlideshow() {
      clearInterval(this.slideshowIntervalId);
    },

    closePopup() {
      clearInterval(this.intervalId);
      this.stopSlideshow();
      this.showPopup = false;
      this.removefixscroll();
    },

    fixscrollshow() {
      document.querySelector('html').classList.add('fix-scroll');
    },

    removefixscroll() {
      document.querySelector('html').classList.remove('fix-scroll');
    },

    showPopupOnlyone() {
      if (this.setAdspopup === '1') {
        this.showPopup = false;
      } else {
        localStorage.setItem('adspopup', '1');
        setTimeout(() => {
          this.startTimer();
          this.startSlideshow();
          this.showPopup = true;
          this.fixscrollshow();
        }, 1500);
      }
    },

    handleBeforeUnload() {
      localStorage.setItem('adspopup', '2');
    }
  },

  created() {
    this.getAds();
    localStorage.setItem('adspopup', '1');
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  },

  mounted() {
    window.addEventListener('resize', this.resizeVueperSlides);
  },

  beforeDestroy() {
    window.removeEventListener('resize', this.resizeVueperSlides);
    this.stopSlideshow();
  }
};
</script>

<style scoped>
:deep(.v-dialog) {
  width: 100% !important;
  height: auto !important;
  box-shadow: none !important;
}

.mb-img {
  width: 100%;
  height: 100%;
  object-fit: contain !important;
}

/* Responsive Dialog Sizes */
@media (min-width: 3000px) { :deep(.v-dialog) { max-width: 1800px !important; } .m-auto-o { height: calc(90vh - 50px); } }
@media (min-width: 2500px) and (max-width: 2999px) { :deep(.v-dialog) { max-width: 1400px !important; } .m-auto-o { height: calc(85vh - 50px); } }
@media (min-width: 1904px) and (max-width: 2499px) { :deep(.v-dialog) { max-width: 1200px !important; } .m-auto-o { height: calc(80vh - 50px); } }
@media (min-width: 1540px) and (max-width: 1903px) { :deep(.v-dialog) { max-width: 1250px !important; } .m-auto-o { height: calc(90vh - 50px); } }
@media (min-width: 1200px) and (max-width: 1539px) { :deep(.v-dialog) { max-width: 1100px !important; } .m-auto-o { height: calc(80vh - 50px); } }
@media (min-width: 1024px) and (max-width: 1199px) { :deep(.v-dialog) { max-width: 950px !important; } .m-auto-o { height: calc(70vh - 50px); } }
@media (min-width: 768px) and (max-width: 1023px) { :deep(.v-dialog) { max-width: 800px !important; } .m-auto-o { height: calc(60vh - 50px); } }
@media (min-width: 600px) and (max-width: 767px) { :deep(.v-dialog) { max-width: 600px !important; } .m-auto-o { height: calc(45vh - 50px); } }
@media (min-width: 480px) and (max-width: 599px) { :deep(.v-dialog) { max-width: 450px !important; } .m-auto-o { height: calc(30vh - 50px); } }
@media (min-width: 380px) and (max-width: 479px) { :deep(.v-dialog) { max-width: 360px !important; } .m-auto-o { height: calc(30vh - 50px); } }
@media (max-width: 379px) { :deep(.v-dialog) { max-width: 320px !important; } .m-auto-o { height: calc(40vh - 50px); } }

@media (max-height: 600px) and (orientation: landscape) {
  .m-auto-o { height: calc(85vh - 50px); }
  .v-dialog--active { margin-top: 20px !important; }
}

.v-dialog__content--active { z-index: 1000000000 !important; }
.v-dialog--active { margin-top: 5vh !important; transition: all 0.3s ease-in-out; }

.position-absolute {
  position: absolute;
  z-index: 9999;
  right: 15px;
  top: 10px;
  transition: all 0.2s ease;
}

.box-x {
  width: 30px;
  height: 30px;
  background: rgba(255, 255, 255, 0.9);
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  transition: all 0.2s ease;
}

.box-x i {
  color: #333;
  font-size: 18px;
  transition: all 0.2s ease;
}

.box-x:hover {
  background: #fff;
  transform: scale(1.1);
}
</style>
